export default function workSchedule_getEstimatedEndDate(userId: ID | null, startDate: Moment, estimatedMinutes: number) {
    const workSchedule = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule()
    return workSchedule.calculateEndDateByDuration(startDate, estimatedMinutes)
}